<template>
  <b-container>

    <div style="display: flex">
      <b-breadcrumb :items="items" style="padding-top: 16px"></b-breadcrumb>
    </div>

    <div v-if="!loaded" class="text-center" style="margin-top: 64px">
      <b-spinner />
    </div>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      allHotels: [],
      hotels: [],
      selectedHotel: {},
      searchText: "",
      loaded: false,
      selectedHotelImage: [],
    };
  },
  mounted() {
      console.log("MOUNTED")
  }
}
</script>


// WEBPACK FOOTER //
// src/components/HotelDetailsJSON.vue